<script lang="ts">
	// @ts-nocheck

	import { page } from '$app/stores';

	interface Props {
		title?: string;
		description?: string;
		keywords?: string;
		canonical?: any;
		siteName?: string;
		imageURL?: string;
		logo?: string;
		author?: string;
		type?: string;
		name?: string;
		index?: boolean;
		twitter?: boolean;
		openGraph?: boolean;
		schemaOrg?: boolean;
		socials?: any;
		children?: import('svelte').Snippet;
	}

	let {
		title = '',
		description = '',
		keywords = '',
		canonical = $page.url,
		siteName = 'Tassie Tours',
		imageURL = '$lib/assets/images/hero-carousel-1.jpg',
		logo = '$lib/assets/logo/logo-black.png',
		author = 'Tassie Tours',
		type = 'website',
		name = 'Tassie Tours',
		index = true,
		twitter = true,
		openGraph = true,
		schemaOrg = false,
		socials = [],
		children
	}: Props = $props();

	let absoluteImageURL = $derived(
		imageURL && !imageURL.startsWith('http') ? `${$page.url.origin}${imageURL}` : imageURL
	);

	// Canonical URL without query strings / hashes to avoid fragmenting signals.
	let canonicalURL = $derived(
		canonical && canonical !== '' && typeof canonical === 'string'
			? canonical
			: `${$page.url.origin}${$page.url.pathname}`
	);

	let Ld = $derived({
		'@context': 'https://schema.org',
		'@type': 'WebPage',
		name: `${name}`,
		url: canonicalURL,
		image: `${absoluteImageURL}`,
		author: {
			'@type': 'Person',
			name: `${author}`
		},
		publisher: {
			'@type': 'Organization',
			name: `${siteName}`,
			logo: {
				'@type': 'ImageObject',
				url: `${logo}`,
				width: 48,
				height: 48
			}
		},
		...(socials && socials.length ? { sameAs: socials } : {})
	});
	let jsonLdScript = $derived(
		`<script type="application/ld+json">${JSON.stringify(Ld)}${'<'}/script>`
	);
</script>

<svelte:head>
	{#if title !== ''}
		<meta name="robots" content={index ? 'index, follow' : 'noindex'} />
		<title>{title}</title>
		<link rel="canonical" href={canonicalURL} />
	{/if}
	{#if description !== ''}
		<meta name="description" content={description} />
	{/if}
	{#if keywords !== ''}
		<meta name="keywords" content={keywords} />
	{/if}
	{#if author !== ''}
		<meta name="author" content={author} />
	{/if}
	{#if openGraph}
		{#if siteName !== ''}
			<meta property="og:site_name" content={siteName} />
		{/if}
		{#if title !== ''}
			<meta property="og:url" content={canonicalURL} />
			<meta property="og:type" content={type} />
			<meta property="og:title" content={title} />
		{/if}
		{#if description !== ''}
			<meta property="og:description" content={description} />
		{/if}
		{#if imageURL !== ''}
			<meta property="og:image" content={absoluteImageURL} />
		{/if}
	{/if}
	{#if twitter}
		{#if title !== ''}
			<meta name="twitter:card" content="summary_large_image" />
			<meta property="twitter:domain" content={$page.url.host} />
			<meta property="twitter:url" content={canonicalURL} />
			<meta name="twitter:title" content={title} />
		{/if}
		{#if description !== ''}
			<meta name="twitter:description" content={description} />
		{/if}
		{#if imageURL !== ''}
			<meta name="twitter:image" content={absoluteImageURL} />
		{/if}
	{/if}
	{@render children?.()}
	{#if schemaOrg || socials[0] !== undefined || logo !== '' || name !== ''}
		{@html jsonLdScript}
	{/if}
</svelte:head>
